module.exports = __webpack_public_path__ + "img/Liquid waste.4473d777.svg";